import React from 'react'
import { FieldProps } from '../../../../../../@types/types'
import SimpleDatepicker from '../../../../../common/inputs/datepicker/SimpleDatepicker'

export type MoveInDateValidationResult = {
  moveInDate?: string[]
}

const MoveInDate: React.FC<FieldProps<MoveInDateValidationResult>> = ({
  insertionData,
  validationMessages,
  screenName,
  wrapperClassName,
  onChange,
}) => {
  const id = `move-in-date`
  const propertyName = 'moveInDate'
  const errors = validationMessages?.moveInDate ?? []
  const selectedDate = insertionData.moveInDate
  const labelTranslationKey = 'wizard.screen.costs.freeFrom'

  return (
    <SimpleDatepicker
      id={id}
      propertyName={propertyName}
      errors={errors}
      selectedDate={selectedDate}
      labelTranslationKey={labelTranslationKey}
      screen={screenName}
      wrapperClassName={wrapperClassName}
      onChange={onChange}
    />
  )
}

export default MoveInDate
